import Vue from 'vue';
import VueRouter from 'vue-router';

import RebateApplicationForm from './views/RebateApplicationForm.vue';
import UserValidationForm from './views/forms/UserValidationForm.vue';
import ReportingForm from './views/forms/ReportingForm.vue';
import FiveZeroZero from './views/FiveZeroZero.vue';
import store from './store';
import { setValidatorLocale } from './utils/veeValidateLocale';

Vue.use(VueRouter);

export const routes = [
  {
    path: '/apply/:applicationId',
    component: RebateApplicationForm,
    props: route => ({
      applicationId: route.params.applicationId,
      isKnownBot: route.query.bot,
      anonymousId: route.query.suid,
      fullScreen: (/true/).test(route.query.fullScreen),
      ocrEnabled: route.query.ocrEnabled,
    }),
    beforeEnter: (to, from, next) => {
      store.commit('customerData/setTrackingCartId', to.query.trackingCartId);

      // Set language from URL parameter and update validator locale
      const lang = to.query.lang || 'en';
      store.commit('language/setLanguage', lang);
      setValidatorLocale(lang);

      // Sets validation bypass code to customerData state if it exists.
      const validationBypassCode = to.query.claim_validation_bypass_code;
      if (validationBypassCode) {
        store.commit('customerData/setValidationBypassCode', validationBypassCode);
      }
      next();
    },
    children: [
      {
        path: '',
        name: 'verification-form',
        component: UserValidationForm,
        props: route => ({
          applicationId: route.params.applicationId,
          customerId: route.query.customerId,
          isKnownBot: route.query.bot,
          anonymousId: route.query.suid,
          fullScreen: (/true/).test(route.query.fullScreen),
          ocrEnabled: route.query.ocrEnabled,
        }),

        beforeEnter: (to, from, next) => {
          store.commit('forms/setCurrentFormIndex', 0);

          // Sets the currentForm state to the form about to be routed so
          // that the form view grabs the correct form object.
          store.commit('forms/setCurrentForm', to.name);
          next();
        },
      },
      {
        path: 'reporting/:index',
        name: 'reporting-form',
        component: ReportingForm,
        props: route => ({
          applicationId: route.params.applicationId,
          isKnownBot: route.query.bot,
          anonymousId: route.query.suid,
          fullScreen: (/true/).test(route.query.fullScreen),
        }),

        beforeEnter: (to, from, next) => {
          store.commit('forms/setCurrentFormIndex', to.params.index);

          // Sets the currentForm state to the form about to be routed so
          // that the form view grabs the correct form object.
          store.commit('forms/setCurrentForm', to.name);
          next();
        },
      },
    ],
  },
  {
    path: '/500',
    name: 'FiveZeroZero',
    component: FiveZeroZero,
    props: route => ({
      fullScreen: (/true/).test(route.query.fullScreen),
    }),
  },
];

export default new VueRouter({
  mode: 'history',
  routes,
});
